<template>

<div class="profile-page">

    <header class="page-header">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <!-- Breadcrumbs -->
                    <nav aria-label="breadcrumb" class="breadcrumb-holder">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="pl-1 pr-1"><span class="icon icon-arrow-right1"></span></li>
                            <li class="breadcrumb-item active" aria-current="page">
                                My Profile
                            </li>
                        </ol>
                    </nav>

                    <h1 class="page-title">
                        My Profile
                    </h1>
                </div>
            </div>
        </div>
    </header>

    <section class="content-section">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-xl-10">
                   
                    <h4 class="text-center mb-4">
                        Personal Information
                    </h4>

                    <div class="row">
                        <div class="col-lg-5">
                            <img-field :model='model' 
                                       :f='"avatar"' ref='img' 
                                       :options='imageOptions'></img-field>
                        </div>

                        <div class="col-lg-7 text-left">

                            <div class="input-group mt-3 mb-4">
                                <label for='name' class="label">Name:</label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <span class="icon icon-user-round"></span>
                                    </span>
                                </div>
                                
                                <input class='form-control' id='name' type="text" v-model='model.name'>
                            </div>

                            <div class="input-group mb-4">
                                <label for='email' class="label">Email:</label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <span class="icon icon-mail1"></span>
                                    </span>
                                </div>
                                <input class='form-control' id='email' type="email" v-model='model.email'>
                            </div>

                            <div class="text-center text-lg-left">
                                <button @click='updateProfile' class='btn btn-primary btn-lg'>
                                    Update Profile
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center my-5">
                <div class="col-11 col-xl-9">
                    <hr>
                </div>
            </div>

            <!-- Password Change -->
            <div class="row d-flex justify-content-center mb-lg-5">
                <div class="col-12 col-xl-10">
                    <h4 class="text-center mb-4">
                        Change Password
                    </h4>
               
                    <div class="row">
                        <div class="col-lg-6">                    
                            <div class="input-group mb-4">
                                <label for="password" class="label"> Old password: </label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="old-pass-icon">
                                        <span class="icon icon-shield-copy"></span>
                                    </span>
                                </div>
                                <input id="current" v-model='pwd.current' type="password" class="form-control" name="old-password" aria-describedby="old-pass-icon" required>
                            </div>
                        </div>                            
                    </div>

                    <div class="row">
                        <div class="col-lg-6">                    
                            <div class="input-group mb-4">
                                <label for="password" class="label"> New password: </label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="new-pass-icon">
                                        <span class="icon icon-shield-copy"></span>
                                    </span>
                                </div>
                                <input id="password" v-model='pwd.password' type="password" class="form-control" name="new-password" aria-describedby="new-pass-icon" required>
                            </div>
                        </div>

                        <div class="col-lg-6">                    
                            <div class="input-group mb-4">
                                <label for="repeat" class="label"> Repeat New password: </label>
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="repeat-pass-icon">
                                        <span class="icon icon-repeat1"></span>
                                    </span>
                                </div>
                                <input id="repeat" v-model='pwd.repeat' type="password" class="form-control" name="repeat-password" aria-describedby="repeat-pass-icon" required>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 text-center mt-3">
                            <form-validator ref='validator' :fields='validatorFields'></form-validator>

                            <button @click='changePassword' class="btn btn-primary btn-lg" >
                                Save password
                            </button>
                        </div>
                    </div>
                        
                </div>
            </div>
        </div>
    </section>
</div>

</template>

<script>
    export default {

        mounted() {

            this.model = Object.assign( {}, this.user );

            this.getData();

            document.body.classList.add('bck-page')

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,                

                current : false,
                history : [],
                model : false,

                pwd : {
                    current     : '',
                    password    : '',
                    repeat      : ''
                },

                imageOptions : {
                    width        : 200,
                    height       : 200,
                    maxFileSize  : 2000000,
                    allowedTypes : ['image/jpeg','image/png'],
                    textTitle    : 'Profile image',
                    wrapperClass : 'place-img-wrap',
                    imageClass   : "place-image",
                    thumbnail    : false
                },

                //Validate User info
                validatorFields : [
                    { 
                        selector  : "#name",
                        minLength : 2,
                        customErr : 'Please write your name'
                    },
                    { 
                        selector  : "#email",
                        minLength : 2,
                        regex     : this.emailRegex,
                        customErr : 'Please write a valid email address'
                    }
                ]
            }
        },

        methods : {

            getData() {

                this.ajax.call('usr:gcp', {}, (r) => {

                    if( r.status == 'success' ) {
                        this.current = r.data.c;
                        this.history = r.data.h;
                        this.isReady = true;
                    }

                })
            },

            changePassword() {

                var me = this;

                if( this.pwd.current.length < 6 ) {
                    $.notify("Please type your current password.","warning");
                    $("#current").focus();
                    return;
                }
                
                if( this.pwd.password.length < 8 ) {
                    $.notify("Please type atleast 8 symbols for new password.","warning");
                    $("#password").focus();
                    return;
                }

                if( this.pwd.password !== this.pwd.repeat ) {
                    $.notify("New password does not match the repeat.","warning");
                    return;
                }

                me.ajax.call('usr:chp', this.pwd, (r) => {
                    me.pwd.current  = '';
                    me.pwd.password = '';
                    me.pwd.repeat   = '';

                    if( r.status == 'success' ) {
                    
                        $.notify('Password updated, redirecting to login','success');

                        setTimeout( () => {
                            location.href = '/login';
                            
                        }, 1000);


                    } else {

                        $.notify( r.message, r.status );

                    }

                })

            },

            updateProfile() {

                var me = this;

                this.$refs.validator.validate({
                    resolve(){

                        me.isLoading = true;

                        me.ajax.call('usr:udp', me.model , (r) => {
                            
                            me.isLoading = false;

                            if( r.status == 'success' ) {

                                $.notify('Your profile was updated','success');

                            } else {

                                $.notify( r.message, r.status );
                            }

                        })

                    }
                })

            },
        },

        components : {

            'user-nl' : require('./UserNewsletter.vue').default

        },

        destroyed() {
            document.body.classList.remove('bck-page')
        }

    }
</script>
